import useTranslation from 'next-translate/useTranslation';

import { getCdnUrl } from '~/domains/assets/utils/getCdnUrl';

import { PromoModalShell, type PromoModalSection } from './PromoModalShell';

export interface MarketplacePromoModalProps {
  isOpen?: boolean;
  isClosing?: boolean;
  onClose?: () => void;
}

const SECTION_KEYS = ['cashOut', 'buyIn', 'sellPartial', 'knowWorth', 'sellOneTap'] as const;

export function MarketplacePromoModal(props: MarketplacePromoModalProps) {
  const { t } = useTranslation('contest');

  const sections: PromoModalSection[] = SECTION_KEYS.map((key) => ({
    title: t(`detail.promoCallouts.marketplace.modal.sections.${key}.title`),
    text: t(`detail.promoCallouts.marketplace.modal.sections.${key}.text`),
  }));

  return (
    <PromoModalShell
      {...props}
      icon={getCdnUrl('/images/promo/contest-detail-marketplace-logo.png')}
      title={t('detail.promoCallouts.marketplace.modal.title')}
      availableLabel={t('detail.promoCallouts.marketplace.available')}
      body={sections}
      note={t('detail.promoCallouts.marketplace.modal.note')}
      dataTestId="contest-detail-marketplace-modal"
    />
  );
}

export default MarketplacePromoModal;
